import { connect } from "react-redux";
import get from "lodash/get";


import {
  updateLogisticControlPointAlarm as onUpdateLogisticControlPointAlarm,
  updateLogisticControlPointVariation as onUpdateLogisticControlPointVariation,
} from "./../../actions/logisticTripControlPointsActions";

const mapStateToProps = (state) => ({
  logisticUpdateTripControlPointAlarmDataState: state.logisticTripControlPoints.logisticUpdateTripControlPointAlarmDataState,
  logisticUpdateTripControlPointVariationDataState: state.logisticTripControlPoints.logisticUpdateTripControlPointVariationDataState,
  errors: get(state, ["logisticTripControlPoints", "errors"], []),
});

const mapDispatchToProps = {
  onUpdateLogisticControlPointAlarm,
  onUpdateLogisticControlPointVariation,
};

const withLogisticTripControlPoints = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withLogisticTripControlPoints };
